import React from "react";

export const multiLineTextFormatter = (cell, row) => {
    return <span style={{ whiteSpace: "normal" }}>{cell}</span>;
  }